module.exports = fox._r("images/sc-ico-sprite.png", __webpack_public_path__ + "_/_/_/common/frame/images/sc-ico-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/sc-ico-sprite.png
// module id = 105
// module chunks = 2